module.exports = __webpack_public_path__ + "img/rjc.83ffe11.jpg";